






















































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Autocomplete from 'vuejs-auto-complete';
// Services
import Staff from '@/services/Staff';
import { Guid } from '@constellation-mutual/guid';
// Components
import Alert from '@/components/Global/Alert.vue';
import Loading from '@/components/Global/Loading.vue';
import TextField from '@/components/Form/TextField.vue';
import SelectField from '@/components/Form/SelectField.vue';
import SwitchField from '@/components/Form/SwitchField.vue';
import TextArea from '@/components/Form/TextArea.vue';
import ActiveDirectory, { ClaimConsultant } from '@/services/ActiveDirectory';
import {
	CaseType,
	LossType,
	Severity,
	Allegations,
	BodyParts,
	Injuries,
	PatientClass,
} from './AdditionalFieldsData';
import { Features } from '@/services/Features';
import axios from 'axios';
import Brand from '@/services/Brand';
import moment from 'moment';
@Component({
	name: 'AdditionalFields',
	components: {
		Alert,
		Loading,
		SelectField,
		TextField,
		TextArea,
		SwitchField,
		Autocomplete,
	},
})
export default class ClaimsSingle extends Vue {
	@Prop() private fields: any;
	@Prop() private realClaimId: any;
	@Prop() private setup: any;
	@Prop() private peerSupportRequested: any;
	@Prop() private peerSupportSwitched: boolean;
	@Prop() private claimNumberUpdated: boolean;
	@Prop() private peerSupportFields: any;

	@Prop() private comments: any;
	@Prop() private assignee: any;
	@Prop() private claim: any;
	@Prop() private isOldClaim: any;
	private readonly Features = Features;

	// Removed for MMIC-484
	// private caseType: string[] = CaseType;
	private lossType = LossType;
	private allegations1 = Allegations;
	private injuries = Injuries;
	private bodyParts = BodyParts;
	private severity = Severity;
	private patientClass = PatientClass;
	private consultants: ClaimConsultant[] = [];
	private selectedClaimConsultant: ClaimConsultant;

	private success: boolean;
	private error: boolean;
	private loading: boolean;
	constructor() {
		super();

		this.success = false;
		this.error = false;
		this.loading = false;
	}
	private async created() {
		this.consultants = await ActiveDirectory.getClaimConsultants('ClaimAll');
		this.consultants = this.consultants.filter(
			consultant => consultant.givenName !== null && consultant.surName !== null,
		);
	}

	private consultantSelected(value) {
		this.fields.claimConsultantName = value.display;

		this.fields.claimConsultantEmail = value.selectedObject.email;
		this.fields.claimConsultantPhone = value.selectedObject.businessPhones[0];
	}

	@Watch('fields', { deep: true })
	private watchFields() {
		this.$emit('update:fields', this.fields);
	}

	@Watch('realClaimId', { deep: true })
	private async watchRealClaimId() {
		this.$emit('update:realClaimId', this.realClaimId);
		this.$emit('update:claimNumberUpdated', true);
		const cpsp = await this.getCurrentCPSPRequest();
		let dateofLoss;
		if (cpsp.DateOfLoss) {
			dateofLoss = cpsp.DateOfLoss;
		} else {
			dateofLoss = Date.parse(moment(this.claim.claim_data.doe).format('YYYY-MM-DD'));
		}
		this.peerSupportFields = {
			Id: cpsp.Id,
			Brand: this.claim.brand,

			NameOfInsured: cpsp.NameOfInsured,
			ClinicHospital: cpsp.ClinicHospital,
			Specialty: cpsp.Specialty,
			CreateDateTime: cpsp.CreateDateTime,
			CasefileNumber: this.realClaimId,
			ClaimConsultantName: cpsp.ClaimConsultantName,
			ClaimConsultantEmail: cpsp.ClaimConsultantEmail,
			ClaimConsultantPhone: cpsp.ClaimConsultantPhone,
			DefenseAttorney: cpsp.DefenseAttorney,
			DefenseAttorneyEmail: cpsp.DefenseAttorneyEmail,
			DescriptionOfOccurrence: cpsp.DescriptionOfOccurrence,
			Comments: cpsp.Comments,
			InsuredEmail: cpsp.InsuredEmail,
			InsuredPhone: cpsp.InsuredPhone,
			ClaimStatus: cpsp.ClaimStatus,
			DateOfLoss: dateofLoss,
		};
		this.$emit('update:peerSupportFields', this.peerSupportFields);
	}

	@Watch('setup', { deep: true })
	private watchSetup() {
		this.$emit('update:setup', this.setup);
	}

	@Watch('peerSupportRequested', { deep: true })
	private async watchRequestPeerSupport() {
		try {
			this.$emit('update:peerSupportRequested', this.peerSupportRequested);
			this.$emit('update:peerSupportSwitched', true);

			if (!this.isOldClaim) {
				this.peerSupportFields = {
					Id: Math.floor(Math.random() * Math.floor(4)),
					brand: this.claim.brand,
					NameOfInsured: this.claim.claim_data.insuredsPolicyInformation.nameOfInsured,
					ClinicHospital: this.claim.claim_data.involvedInsuredsHealthCareProviders
						.providers[0].buildingOrganization,
					Specialty: this.claim.claim_data.involvedInsuredsHealthCareProviders
						.providers[0].designation,
					PreferredContactMethod: this.claim.claim_data
						.preferred_communicationsSubmittedBy,

					CasefileNumber: this.realClaimId,
					ClaimConsultantName: this.fields.claimConsultantName,
					ClaimConsultantEmail: this.fields.claimConsultantEmail,
					ClaimConsultantPhone: this.fields.claimConsultantPhone,
					DefenseAttorney: '',
					DefenseAttorneyEmail: '',
					DescriptionOfOccurrence: this.claim.claim_data.informationAboutTheClaimIncident
						.descriptionOfIncident,
					Comments: this.comments,
					InsuredEmail: this.claim.claim_data.involvedInsuredsHealthCareProviders
						.providers[0].emailAddress,
					InsuredPhone: this.claim.claim_data.involvedInsuredsHealthCareProviders
						.providers[0].phoneNumber,
					ClaimStatus: this.claim.claim_status,
					DateOfLoss: moment(
						this.claim.claim_data.informationAboutTheClaimIncident.dateOfIncident,
					).format('YYYY-MM-DD'),
				};
			} else {
				this.peerSupportFields = {
					Id: Math.floor(Math.random() * Math.floor(4)),
					brand: this.claim.brand,
					NameOfInsured: this.claim.claim_data.name,
					ClinicHospital: '',
					Specialty: '',
					PreferredContactMethod: this.claim.claim_data
						.preferred_communicationsSubmittedBy,

					CasefileNumber: this.realClaimId,
					ClaimConsultantName: this.fields.claimConsultantName,
					ClaimConsultantEmail: this.fields.claimConsultantEmail,
					ClaimConsultantPhone: this.fields.claimConsultantPhone,
					DefenseAttorney: '',
					DefenseAttorneyEmail: '',
					DescriptionOfOccurrence: this.claim.claim_data.description,
					Comments: this.comments,
					InsuredEmail: this.claim.claim_data.emailHCP,
					InsuredPhone: this.claim.claim_data.phoneHCP,
					ClaimStatus: this.claim.claim_status,
					DateOfLoss: moment(this.claim.claim_data.doe).format('YYYY-MM-DD'),
				};
			}

			this.peerSupportFields = this.removeEmpty(this.peerSupportFields);

			this.$emit('update:peerSupportFields', this.peerSupportFields);
		} catch (e) {
			console.log('error');
			console.log(e);
		} finally {
			console.log('finally');
		}
	}

	private async getCurrentCPSPRequest() {
		try {
			let cpspList = await Staff.readCPSPSupportRequests();
			this.success = true;
			this.error = false;

			cpspList = cpspList.sort((a, b) => {
				return new Date(a.CreateDateTime) > new Date(b.CreateDateTime)
					? -1
					: new Date(a.CreateDateTime) < new Date(b.CreateDateTime)
					? 1
					: 0;
			});
			const that = this;
			const cpsp = cpspList.filter(
				cpsp =>
					cpsp.NameOfInsured ===
					that.claim.claim_data.insuredsPolicyInformation.nameOfInsured,
			);
			console.log('cpsp', cpsp);
			return cpsp[0];
		} catch (e) {
			console.log('error');
			this.error = true;
			this.success = false;
		} finally {
			console.log('finally');
			this.loading = false;
		}
	}
	private removeEmpty(obj) {
		return Object.keys(obj)
			.filter(key => obj[key])
			.reduce((newObj, key) => {
				newObj[key] = obj[key];
				return newObj;
			}, {});
	}
	@Watch('comments', { deep: true })
	private watchComments() {
		this.$emit('update:comments', this.comments);
	}

	@Watch('assignee', { deep: true })
	private watchAssignee() {
		this.$emit('update:assignee', this.assignee);
	}
}
